import {FacilitarAgilizarProcesos} from './FacilitarAgilizarProcesos';
export default FacilitarAgilizarProcesos;
